<route>
{
  "meta": {
    "auth": "checkReview"
  }
}
</route>

<template>
  <div>
    <el-card class="container">
      <el-page-header style="margin-bottom: 30px;" @back="$router.back()"> </el-page-header>
      <div class="assets">
        <div class="title">
          账户信息
        </div>
        <div class="content">
          <div class="item" v-for="item in accountInfo" :key="item.prop">
            <div class="label">{{ item.label }}：</div>
            <div class="value" v-if="item.prop === 'bankAccountType'">
              {{ accountData[item.prop] | bankType }}
            </div>
            <div class="value" v-else>{{ accountData[item.prop] || '未绑定' }}</div>
            <!-- </div> -->
          </div>
        </div>

        <div class="title" style="margin-top:40px">资金管理</div>
        <div class="money">
          <div class="item" v-for="item in moneyInfo" :key="item.prop">
            <div class="label">
              {{ item.label }}
              <div class="value">
                {{ data[item.prop] }}
              </div>
            </div>
          </div>
        </div>

        <div class="confirmWithdraw">
          <div>
            <span>提现金额:</span>
            <el-input
              class="input"
              v-model.trim="data.money"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              placeholder="请输入提现金额"
              clearable
            ></el-input>
          </div>
          <el-button
            class="confirmBtn"
            type="primary"
            :disabled="data.money == 0 || accountData.accountNumber == '' || data.money > data.canWithdrawAmount"
            @click="confirmWithdraw"
            >提现</el-button
          >
          <div class="tip" v-if="accountData.accountNumber === ''">请为该二级商户号绑定银行卡</div>
        </div>
      </div>
      <div class="take-table">
        <div class="header">
          <div class="label">起止时间</div>
          <el-date-picker
            v-model="filter.date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <div class="label" style="margin-left:30px">操作人昵称</div>
          <el-input style="width:280px" v-model="filter.operatorName"></el-input>
          <div class="label" style="margin-left:30px">操作人ID</div>
          <el-input style="width:280px" v-model="filter.operatorId"></el-input>
          <div class="btns">
            <el-button type="warning" @click="resetSearch">重置</el-button>
            <el-button type="success" @click="getList">搜索</el-button>
          </div>
        </div>
        <el-table :loading="loading" :data="table.list">
          <el-table-column
            v-for="item in table.cols"
            align="center"
            :key="item.label"
            :prop="item.prop"
            :label="item.label"
          >
            <template slot-scope="{ row }">
              <div class="" v-if="item.prop === 'applyTime'">{{ row[item.prop] | formatTime }}</div>
              <div v-else-if="item.prop === 'applyWithdrawStatus'">
                {{ table.applyWithdrawStatus[row[item.prop]] }}
              </div>
              <div v-else>{{ row[item.prop] }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      @close="confirmDialog = false"
      :visible="confirmDialog"
      title="滑动确认提现"
      class="assets"
      width="400px"
    >
      <bm-dragverify
        :key="id"
        :width="350"
        :height="40"
        text="按住滑块向右拖动确认"
        @passcallback="finish"
        success-text="系统提示:正在处理中"
      ></bm-dragverify>
    </el-dialog>
  </div>
</template>

<script>
import { pagination } from '@/mixin/pagination'
export default {
  mixins: [pagination],
  data() {
    return {
      accountInfo: [
        {
          label: '账号名称',
          prop: 'accountName'
        },
        {
          label: '开户银行',
          prop: 'accountBank'
        },
        {
          label: '银行账号',
          prop: 'accountNumber'
        },
        {
          label: '对账类型',
          prop: 'bankAccountType'
        }
      ],
      moneyInfo: [
        {
          label: '账上总金额',
          prop: 'accountAmount'
        },
        {
          label: '未核销金额',
          prop: 'waitCheckAmount'
        },
        {
          label: '其它资产总金额',
          prop: 'otherAmount'
        },
        {
          label: '已核销金额',
          prop: 'checkoffAmount'
        },
        {
          label: '可提现金额',
          prop: 'canWithdrawAmount'
        },
        {
          label: '已提现金额',
          prop: 'hadWithdrawAmount'
        }
      ],
      data: {
        can: false,
        money: '',
        aheadWithdrawMoney: 0.2,
        bankAccountType: '75',
        canWithdrawMoney: 0,
        frozenMoney: 5.94,
        haveWithdrawMoney: 17.39,
        tenantId: 0,
        totalAccountMoney: 7.46,
        unconfirmedMoney: 1.52
      },
      confirmDialog: false,
      id: new Date().toString(),
      filter: {
        date: [],
        order: ''
      },
      loading: false,
      table: {
        list: [],
        cols: [
          {
            label: '提现金额',
            prop: 'withdrawAmount'
          },
          {
            label: '操作人',
            prop: 'operatorName'
          },
          {
            label: '操作ID',
            prop: 'operatorId'
          },

          {
            label: '操作时间',
            prop: 'applyTime'
          },
          {
            label: '银行卡号',
            prop: 'accountNumber'
          },
          {
            label: '状态',
            prop: 'applyWithdrawStatus'
          }
        ],
        applyWithdrawStatus: {
          0: '发起提现',
          1: '调用接口失败',
          2: '提现成功',
          3: '提现失败'
        }
      },
      dialog: {
        show: false,
        type: 'view',
        subMerchantId: 0
      }
    }
  },
  created() {
    this.dialog.subMerchantId = this.$route.query.subMerchantId
    this.getDetail()
    this.accountData = JSON.parse(sessionStorage.accountInfo)
  },
  computed: {
    canWithdraw() {
      if (this.data.accountNumber === '' || this.data.money === '') {
        return true
      }
      return false
    }
  },
  methods: {
    finish() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$http
        .post('/boom-mix-biz-service/sysAdmin/business-sub-mch-withdraw', {
          businessId: this.$store.getters['vendor/params/getVendorId'],
          subMchid: this.$store.getters['vendor/params/getAccountId'],
          money: this.data.money
        })
        .then(() => {
          this.getList()
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
        .finally(() => {
          this.getDetail()
          this.data.money = ''
          loading.close()
          this.id = new Date().toString()
          this.confirmDialog = false
        })
    },
    confirmWithdraw() {
      this.confirmDialog = true
    },
    getDetail() {
      this.$http
        .get('/boom-center-order-service/sysAdmin/business-sub-mch-withdraw/summary', {
          params: {
            businessId: this.$store.getters['vendor/params/getVendorId'],
            subMchid: this.$store.getters['vendor/params/getAccountId']
          }
        })
        .then(res => {
          this.data = { ...this.data, ...res }

          console.log(this.data)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    resetSearch() {
      this.filter = {
        date: [],
        businessId: this.$store.getters['vendor/params/getVendorId'],
        subMchid: this.$store.getters['vendor/params/getAccountId'],
        operatorId: '',
        operatorName: ''
      }
      this.getList()
    },
    getList(page = 1) {
      this.loading = true
      this.currentPage = page === true ? this.currentPage : 1
      console.log(this.filter.date)
      let params = {
        params: {
          page: this.currentPage,
          businessId: this.$store.getters['vendor/params/getVendorId'],
          subMchid: this.$store.getters['vendor/params/getAccountId'],
          startTime: this.filter.date.length ? new Date(this.filter.date[0]).getTime() : undefined,
          endTime: this.filter.date.length ? new Date(this.filter.date[1]).getTime() : undefined,
          operatorId: this.filter.operatorId ? this.filter.operatorId : undefined,
          operatorName: this.filter.operatorName ? this.filter.operatorName : undefined
        }
      }

      this.$http
        .get('/boom-center-order-service/sysAdmin/business-sub-mch-withdraw/records', params)
        .then(res => {
          console.log(res)
          this.total = parseInt(res.total)
          this.table.list = res.list
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
        .finally(() => (this.loading = false))
    }
  },
  filters: {
    bankType(value) {
      if (value == '74') {
        return '对公银行账户'
      } else if (value == 75) {
        return '经营者个人银行卡'
      } else {
        return '未绑定'
      }
    },
    formatStatus(value) {
      if (value == 0) {
        return '发起提现'
      } else if (value == 1) {
        return '调用接口失败'
      } else if (value == 2) {
        return '提现成功'
      } else if (value == 3) {
      } else {
        return '提现失败'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: calc(100vh - 50px);
  background: #f9f9f9;
}
.assets {
  background: #fff;
  padding: 20px;
  margin-bottom: 30px;
  .title {
    font-size: 15px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content {
    display: flex;
    .item {
      flex-basis: 50%;
      display: flex;
      font-size: 15px;
      overflow: hidden;
      padding-right: 15px;
      .label {
        color: #999;
      }
      .value {
        flex: 1;
        overflow: hidden;
        word-break: break-all;
      }
    }
  }
  .money {
    display: flex;
    background: #f7f7f7;
    padding: 30px;
    .item {
      flex: 1;
      word-break: break-all;
      text-align: center;
      .label {
        color: #999;
        font-size: 15px;
        margin-bottom: 5px;
      }
      .value {
        color: #e7141a;
        font-weight: bold;
        font-size: 26px;
      }
    }
  }
  .accountItem {
    margin: 16px 0;
    font-size: 18px;
    .intro {
      display: inline-block;
      width: 200px;
    }
    span {
      font-size: 16px;
      font-weight: 100;
    }
  }

  .confirmWithdraw {
    display: flex;
    align-items: center;
    margin-top: 15px;
    span {
      font-size: 15px;
      margin-right: 10px;
    }
    .input {
      width: 250px;
    }
    .confirmBtn {
      width: 100px;
      margin: 0 15px;
    }
    .tip {
      // text-align: center;
      color: red;
      font-size: 12px;
    }
  }
}
.take-table {
  margin-top: 30px;
  background: #fff;
  padding: 20px;
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .label {
      font-size: 15px;
      margin-right: 10px;
    }
    .btns {
      flex: 1;
      text-align: right;
    }
  }
  .footer {
    text-align: right;
    margin-top: 15px;
  }
}
</style>
